import { styled } from '@mui/material/styles';
import { Box, Box as MuiBox } from '@mui/material';

export const MobileCardsWrapper = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  padding: '0rem',
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export const MobileCardContainer = styled(MuiBox)(({ theme }) => ({
  border: `0.0625px solid ${theme.palette.divider}`,
  borderRadius: '0.5rem',
  padding: '1rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  backgroundColor: theme.palette.primary.main,
  boxShadow: theme.shadows[0],
}));

export const MobileCardLine = styled(MuiBox)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const TextOpacity = styled(Box)(() => ({
  opacity: '0.5',
}));